import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () => ({ breakpoints }: Theme) =>
  createStyles({
    item: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 5px 10px 10px',
      [breakpoints.down(575)]: {
        padding: '10px 5px 10px 25px',
      },
    },
    titleCard: { fontSize: 12, fontWeight: 500 },
    cardSubtitleText: { fontSize: 12, marginRight: 4 },
    cardSubtitleValue: { fontSize: 12, fontWeight: 'bold' },
    subtitleGrid: { paddingTop: 5 },
    valueCard: { fontWeight: 'bold' },
    valueCardGray: { color: palette.navSuperAdminActions },
    valueCardGreen: { color: palette.navAdminActions },
    valueCardBlue: { color: palette.navOperatorActions },
    valueCardYellow: { color: palette.navCompanyContextActions },
    containerCard: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      maxWidth: '33%',
      flex: 1,
      [breakpoints.down('md')]: {
        flex: '0 0 33%',
      },
    },
  });

export const overrideCard = breakpoints => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: 130,
  padding: 8,
  '&:after': {
    content: '""',
    position: 'absolute',
    [breakpoints.down(575)]: {
      width: 215,
    },
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    [breakpoints.down(575)]: {
      right: -48,
    },
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});
